<template>
  <div>
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === "" && Object.keys(formulario1).length >= 1'>
      <div class="rf-contrato-modelo">
        <div class="rf-modelo-config" style="overflow: hidden;">
          <div class="rf-modelo-config-bts">
            <RF-Button v-if="formulario1.field.modelo.value !== '' && formulario1.hasOwnProperty('ver')"
              :data-time='time'

              :cpntStatus='formulario1.ver.status' 
              :cpntId='formulario1.ver.id' 
              :cpntTexto='formulario1.ver.texto' 
              :cpntClass='formulario1.ver.class'
              :cpntMostrar='formulario1.ver.mostrar'
              :cpntTabIndex='formulario1.ver.tabIndex'

              @onClickButton='formulario1.ver.onClick("ver")'
            ></RF-Button>
          </div>

          <RF-Formulario :data-time='time' :style='(formulario1.field.modelo.value !== "" ? "padding-bottom: 190px; overflow: auto; height: 100%;" : "")'
            :cpntTime='time'
            :cpntId='formulario1.id' 
            :cpntStatus='formulario1.status'
            :cpntField='formulario1.field'
            :cpntUltAlt='formulario1.ult_alt'
            :cpntButtons='formulario1.buttons'
            :cpntTabIndexFieldGeral='formulario1.tabIndexFieldGeral'
            :cpntTabIndexButtonGeral='formulario1.tabIndexButtonGeral'

            :ref='formulario1.id'
          ></RF-Formulario>
        </div>

        <div class="rf-modelo-conteudo" style="min-height: 315px;">
          <template v-if="formulario1.field.modelo.value !== '' && formulario1.field.referencia.value !== '0' && formulario1.field.referencia.value !== ''">
            <template v-if="formulario1.field.modelo.value !== '0' && formulario1.field.modelo.value !== ''" v-for="(campo, index) in arrayModelo" style="min-height: 100%;">
              <div :key="'div-0-' + index" class="ctr-modelo-con" v-if="campo.acao !== undefined" style="background: none;">
                <div class="ctr-modelo-con-info">
                  <span class="ctr-modelo-con-info-acao" :title="(campo.acao !== 'voltar-item' ? novoOption.opcoes.filter(item => item.index === campo.acao)[0].title : '')">
                    <template v-if="campo.hasOwnProperty('editar') && campo.editar === false">
                      <span v-if="campo.np !== 'n'" style="color: #4141d2; font-weight: 600;">[NOVA PÁGINA - {{ campo.np }}]</span>
                    </template>
                    <span v-else-if="campo.hasOwnProperty('novaPagina') && campo.hasOwnProperty('editar') && campo.editar === true" class="rf-checkbox">
                      <RF-Select2 style="margin: 15px 0px 14px 0px; width: 150px; text-align: center;"
                        :data-time="time" :class='"rf-field-tamanho-" + (campo.novaPagina.hasOwnProperty("tamanho") ? campo.novaPagina.tamanho : 0) + " rf-field-novaPagina-" + campo.inserirAqui.value'

                        :cpntStatus='campo.novaPagina.status'
                        :cpntId='campo.novaPagina.id'
                        :cpntClassDivField='campo.novaPagina.classDivField'
                        :cpntNome='campo.novaPagina.nome'
                        :cpntValue='campo.novaPagina.value'
                        :cpntOptions='(index === 1 ? campo.novaPagina.options.filter(item => item.id !== "n") : campo.novaPagina.options)'
                        :cpntKeyValue='campo.novaPagina.keyValue'
                        :cpntKeyMostra='campo.novaPagina.keyMostra'
                        :cpntAutoComplete='campo.novaPagina.autocomplete'
                        :cpntDisabled='campo.novaPagina.disabled'
                        :cpntMostrar='campo.novaPagina.mostrar'
                        :cpntMensagem='campo.novaPagina.mensagem'
                        :cpntOptionInicialNome='campo.novaPagina.optionInicialNome'
                        :cpntOptionInicialValue='campo.novaPagina.optionInicialValue'
                        :cpntMensagemTipo='campo.novaPagina.mensagemTipo'
                        :cpntAddOption='campo.novaPagina.addOption'
                        :cpntMultiple='campo.novaPagina.multiple'
                        :cpntExplica='campo.novaPagina.explica'
                        :cpntClassSelect='campo.novaPagina.classSelect2'
                        :cpntTabIndex='campo.novaPagina.tabIndex'

                        :cpntOnKeyPressEnter='campo.novaPagina.onKeyPressEnter'
                        :cpntOnChange='campo.novaPagina.onChange'
                        :cpntOnBlur='campo.novaPagina.onBlur'
                        :ref='campo.novaPagina.tipo'
                      ></RF-Select2>

                      <!-- <input
                        type="checkbox"

                        :data-time='time'
                        :id='formulario1.id + "--editar-novaPagina--" + index + "--novaPagina"' 
                        :checked='campo.campoExtra.novaPagina'
                        @change='contratosModeloConteudoOnChange(!campo.campoExtra.novaPagina, formulario1.id + "--editar-novaPagina--" + index + "--novaPagina")'>
                      <label :for='formulario1.id + "--editar-novaPagina--" + index + "--novaPagina"' 
                       style="color: #444; font-weight: bold !important; margin-bottom: 0px; cursor: pointer;">[NOVA PÁGINA]</label> -->
                    </span>

                    <!-- ({{ campo.id }} - {{ campo.acao }}) -->
                    <!-- <span v-if="campo.acao === 'item'">Item</span> -->
                    <!-- <span v-else-if="campo.acao === 'subitem'">Subitem</span> -->
                    <span v-if="campo.acao === 'conteudo'">Conteudo</span>
                    <!-- <span v-else-if="campo.acao === 'sumario'">Sumário</span> -->
                    <span v-else-if="campo.acao === 'ini-numeracao'">Numeração</span>
                    <!-- <span v-else-if="campo.acao === 'voltar-item'">Item</span> -->
                    <!-- <span v-else style="color: red; font-weight: bold;">@@@ ERRO AQUI @@@ {{ campo.acao }}</span> -->
                  </span>

                  <div class="ctr-modelo-con-info-bts">
                    <template v-if="campo.hasOwnProperty('editar') && campo.editar === false">
                      <RF-Button 
                        :data-time='time'

                        :cpntId='formulario1.id + "-bt-editar"'
                        :cpntStatus='""' 
                        :cpntTipo='"editar"'
                        :cpntClass='[ "button-acoes-conteudo-modelo", "btn", "btn-warning", "btn-sm" ]'

                        @onClickButton="contratosModeloConteudoEditar(index)"
                      ></RF-Button>
                      <RF-Button 
                        :data-time='time'

                        :cpntId='formulario1.id + "-bt-excluir"'
                        :cpntStatus='""' 
                        :cpntTipo='"excluir"'
                        :cpntClass='[ "button-acoes-conteudo-modelo", "btn", "btn-danger", "btn-sm" ]'

                        @onClickButton="contratosModeloConteudoExcluir(campo.id)"
                      ></RF-Button>
                    </template>
                    <template v-else-if="campo.hasOwnProperty('editar') && campo.editar === true">
                      <RF-Button 
                        :data-time='time'

                        :cpntId='formulario1.id + "-bt-modificar"'
                        :cpntStatus='""' 
                        :cpntIcone='"fa fa-retweet"'
                        :cpntClass='[ "button-acoes-conteudo-modelo", "btn", "btn-warning", "btn-sm" ]'

                        @onClickButton="contratosModeloConteudoAtaulizar(campo.id, index)"
                      ></RF-Button>
                      <RF-Button 
                        :data-time='time'

                        :cpntId='formulario1.id + "-bt-cancelar"'
                        :cpntStatus='""' 
                        :cpntIcone='"fa fa-times"'
                        :cpntClass='[ "button-acoes-conteudo-modelo", "btn", "btn-default", "btn-sm" ]'

                        @onClickButton="contratosModeloConteudoEditar(index)"
                      ></RF-Button>
                    </template>
                  </div>
                </div>

                <template v-if="campo.hasOwnProperty('editar') && campo.editar === false">
                  <table style="width: 100%;">
                    <tr>
                      <td v-for="n in campo.indicePadding" :key="n" style="vertical-align: top; width: 17px;">---</td>
                      <td class="ctr-modelo-con-item" style="padding-left: 8px;">
                        <span v-if="[ 'item', 'subitem', 'voltar-item' ].indexOf(campo.acao) !== -1">
                          <span style="color: rgb(65, 136, 168); font-weight: 600;">{{ campo.indice }}</span> - {{ campo.conteudo }}
                        </span>
                       <!--  <span v-else-if="[ 'layout' ].indexOf(campo.acao) !== -1">
                          {{ layout.filter(item => item.nome === campo.conteudo)[0].nome }}
                        </span> -->
                        <span v-else-if="[ 'conteudo', 'sumario' ].indexOf(campo.acao) !== -1">
                          <span v-html="campo.conteudo"></span>
                        </span>
                      </td>
                    </tr>
                  </table>
                </template>
                <div v-else-if="campo.hasOwnProperty('editar') && campo.editar === true"  class="ctr-modelo-con-item-editar">
                  <table style="width: 100%;">
                    <tr>
                      <td v-if="[ 'item', 'subitem', 'voltar-item' ].indexOf(campo.acao) !== -1" :style="campo.indice.length >= 2 ? ('width: ' + (campo.indice.length * 9.8) + 'px;') : 'width: 18px;'">
                        <span style="color: rgb(65, 136, 168); font-weight: 600;">{{ campo.indice }} </span> - 
                      </td>
                      <td>
                        <div v-if="[ 'ini-numeracao' ].indexOf(campo.acao) !== -1" style="min-height: 36px;">
                          &nbsp;
                        </div>
                        <RF-Input v-else-if='campo.campoExtra.tipo === "input"'
                          :data-time="time" 
                          :class='"rf-field-tamanho-" + (campo.campoExtra.hasOwnProperty("tamanho") ? campo.campoExtra.tamanho : 0) + " rf-field-campoExtra-" + campo.acao'

                          :cpntStatus='campo.campoExtra.status'
                          :cpntId='campo.campoExtra.id'
                          :cpntTabIndex='campo.campoExtra.tabIndex'
                          :cpntClassDivField='campo.campoExtra.classDivField'
                          :cpntNome='campo.campoExtra.nome'
                          :cpntValue='campo.campoExtra.value'
                          :cpntType='campo.campoExtra.type'
                          :cpntAutoComplete='campo.campoExtra.autocomplete'
                          :cpntMask='campo.campoExtra.mask'
                          :cpntDisabled='campo.campoExtra.disabled'
                          :cpntMostrar='campo.campoExtra.mostrar'
                          :cpntAutoFocus='campo.campoExtra.autofocus'
                          :cpntMensagem='campo.campoExtra.mensagem'
                          :cpntMensagemTipo='campo.campoExtra.mensagemTipo'
                          :cpntPlaceholder='campo.campoExtra.placeholder'
                          :cpntExplica='campo.campoExtra.explica'
                          :cpntMaxLength='campo.campoExtra.maxLength'

                          :cpntOnChange='campo.campoExtra.onChange'
                          :cpntOnBlur='campo.campoExtra.onBlur'
                          :cpntOnKeyPressEnter='campo.campoExtra.onKeyPressEnter'
                          :ref='campo.campoExtra.tipo'
                        ></RF-Input>

                        <div v-else-if='campo.campoExtra.tipo === "ckeditor"'>
                          <RF-Ckeditor style="width: 100%;"
                            :data-time="time" :class='"rf-field-tamanho-" + (campo.campoExtra.hasOwnProperty("tamanho") ? campo.campoExtra.tamanho : 0) + " rf-field-campoExtra-" + campo.acao'

                            :cpntStatus='campo.campoExtra.status'
                            :cpntId='campo.campoExtra.id'
                            :cpntClassDivField='campo.campoExtra.classDivField'
                            :cpntNome='campo.campoExtra.nome'
                            :cpntValue='campo.campoExtra.value'
                            :cpntAutoComplete='campo.campoExtra.autocomplete'
                            :cpntDisabled='campo.campoExtra.disabled'
                            :cpntMostrar='campo.campoExtra.mostrar'
                            :cpntMensagem='campo.campoExtra.mensagem'
                            :cpntMensagemTipo='campo.campoExtra.mensagemTipo'
                            :cpntConfig='campo.campoExtra.config'
                            :cpntExplica='campo.campoExtra.explica'
                            :cpntTabIndex='campo.campoExtra.tabIndex'

                            :cpntOnChange='campo.campoExtra.onChange'
                            :cpntOnBlur='campo.campoExtra.onBlur'
                            :ref='campo.campoExtra.tipo'
                          ></RF-Ckeditor>
                        </div>

                        <RF-Select2 v-else-if='campo.campoExtra.tipo === "select2"' 
                          :data-time="time" :class='"rf-field-tamanho-" + (campo.campoExtra.hasOwnProperty("tamanho") ? campo.campoExtra.tamanho : 0) + " rf-field-campoExtra-" + campo.acao'

                          :cpntStatus='campo.campoExtra.status'
                          :cpntId='campo.campoExtra.id'
                          :cpntClassDivField='campo.campoExtra.classDivField'
                          :cpntNome='campo.campoExtra.nome'
                          :cpntValue='campo.campoExtra.value'
                          :cpntOptions='campo.campoExtra.options'
                          :cpntKeyValue='campo.campoExtra.keyValue'
                          :cpntKeyMostra='campo.campoExtra.keyMostra'
                          :cpntAutoComplete='campo.campoExtra.autocomplete'
                          :cpntDisabled='campo.campoExtra.disabled'
                          :cpntMostrar='campo.campoExtra.mostrar'
                          :cpntMensagem='campo.campoExtra.mensagem'
                          :cpntOptionInicialNome='campo.campoExtra.optionInicialNome'
                          :cpntOptionInicialValue='campo.campoExtra.optionInicialValue'
                          :cpntMensagemTipo='campo.campoExtra.mensagemTipo'
                          :cpntAddOption='campo.campoExtra.addOption'
                          :cpntMultiple='campo.campoExtra.multiple'
                          :cpntExplica='campo.campoExtra.explica'
                          :cpntClassSelect='campo.campoExtra.classSelect2'
                          :cpntTabIndex='campo.campoExtra.tabIndex'

                          :cpntOnKeyPressEnter='campo.campoExtra.onKeyPressEnter'
                          :cpntOnChange='campo.campoExtra.onChange'
                          :cpntOnBlur='campo.campoExtra.onBlur'
                          :ref='campo.campoExtra.tipo'
                        ></RF-Select2>
                      </td>  
                    </tr>
                  </table>

                </div>
              </div>

              <div :key="'div-1-' + index" v-if="campo.inserirAqui === false">
                <RF-Button
                  :data-time='time'

                  :cpntStatus='""' 
                  :cpntId='formulario1.id + "--barra-opcoes--" + index + "--bt-geral"' 
                  :cpntTexto='"Inserir aqui"' 
                  :cpntClass='[ "btn", "btn-default", "btn-sm" ]'
                  :cpntMostrar='true'

                  @onClickButton='contratosModeloConteudoInserirAqui(index)'
                ></RF-Button>
              </div>

              <div :key="'div-2-' + index" class="ctr-modelo-con" v-else>
                <template v-if="typeof campo.inserirAqui !== 'object' && Object.keys(campo.inserirAqui).length >= 0">
                  Carregando...
                </template>
                <template v-else-if="typeof campo.inserirAqui === 'object' && Object.keys(campo.inserirAqui).length >= 1">
                  <!-- <table style="width: 100%;">
                    <tr>
                      <td v-for="(opcao, opcaoIndex) in campo.inserirAqui" v-if="opcao.hasOwnProperty('nome') && opcaoIndex !== 'campoExtra'" class="rf-checkbox" :style="'padding: 0px; width: ' + (100 / Object.keys(campo.inserirAqui).length) + '%;'">
                        <RF-Button style="width: 175px; margin: 0px 2px;"
                          :data-time='time'

                          :cpntStatus='""' 
                          :cpntId='formulario1.id + "--barra-opcoes--" + index + "--" + opcaoIndex' 
                          :cpntTexto='opcao.nome + ((opcao.hasOwnProperty("indice") && opcao.indice !== "") ? (" " + opcao.indice) : "")' 
                          :cpntClass='campo.inserirAqui.value === opcaoIndex ? [ "btn", "btn-primary", "btn-sm" ] : [ "btn", "btn-default", "btn-sm" ]'
                          :cpntMostrar='true'
                          :cpntDisabled="opcao.disable === '1'"
                          :cpntExplica="(opcao.hasOwnProperty('title') && opcao.title !== '') ? { mensagem: opcao.title, positionMy: 'top right', positionAt: 'bottom left' } : ''"

                          @onClickButton='contratosModeloConteudoOnChange(opcaoIndex, formulario1.id + "--barra-opcoes--" + index + "--" + opcaoIndex)'
                        ></RF-Button>

                        <!- <input
                          type="radio"

                          :data-time='time'
                          :id='formulario1.id + "--barra-opcoes--" + index + "--" + opcaoIndex' 
                          :name='formulario1.id + "--barra-opcoes--" + index' 
                          :value="opcaoIndex" 
                          :checked='campo.inserirAqui.value === opcaoIndex'
                          :disabled="opcao.disable === '1'"
                          @change='contratosModeloConteudoOnChange(opcaoIndex, formulario1.id + "--barra-opcoes--" + index + "--" + opcaoIndex)'>
                        <label :for='formulario1.id + "--barra-opcoes--" + index + "--" + opcaoIndex' style="margin-bottom: 0px; cursor: pointer;"><br/>{{ opcao.nome }} {{ opcao.indice }}</label>->
                      </td>
                    </tr>
                  </table> -->

                  <RF-Button v-for="(opcao, opcaoIndex) in campo.inserirAqui" :key="opcaoIndex" v-if="opcao.hasOwnProperty('nome') && opcaoIndex !== 'campoExtra' && opcaoIndex !== 'novaPagina'"
                    style="width: 155px; margin: 5px;"
                    :data-time='time'

                    :cpntStatus='""' 
                    :cpntId='formulario1.id + "--barra-opcoes--" + index + "--" + opcaoIndex' 
                    :cpntTexto='opcao.nome + ((opcao.hasOwnProperty("indice") && opcao.indice !== "") ? (" " + opcao.indice) : "")' 
                    :cpntClass='campo.inserirAqui.value === opcaoIndex ? [ "btn", "btn-primary", "btn-sm" ] : [ "btn", "btn-default", "btn-sm" ]'
                    :cpntMostrar='true'
                    :cpntDisabled="opcao.disable === '1'"
                    :cpntExplica="(opcao.hasOwnProperty('title') && opcao.title !== '') ? { mensagem: opcao.title, positionMy: 'top right', positionAt: 'bottom left' } : ''"

                    @onClickButton='contratosModeloConteudoOnChange(opcaoIndex, formulario1.id + "--barra-opcoes--" + index + "--" + opcaoIndex)'
                  ></RF-Button>

                  <div v-if="campo.inserirAqui.hasOwnProperty('editar') && campo.inserirAqui.editar === true"  class="ctr-modelo-con-item-editar" style='text-align: center;'>
                    <!-- <span v-if="[ 'item', 'subitem' ].indexOf(campo.inserirAqui.acao) !== -1">
                      <span style="color: rgb(65, 136, 168); font-weight: 600;">{{ campo.inserirAqui.indice }}</span> - 
                    </span> -->

                    <RF-Select2 v-if='campo.inserirAqui.value === "voltar-item"' style="display: inline-block; margin-top: 25px; text-align: center; width: 100px; margin-bottom: 0px;"
                      :data-time="time" :class='"rf-field-tamanho-" + (campo.inserirAqui.campoExtra.hasOwnProperty("tamanho") ? campo.inserirAqui.campoExtra.tamanho : 0) + " rf-field-campoExtra-" + campo.inserirAqui.value'

                      :cpntStatus='campo.inserirAqui.campoExtra.status'
                      :cpntId='campo.inserirAqui.campoExtra.id + "-recuo"'
                      :cpntClassDivField='campo.inserirAqui.campoExtra.classDivField'
                      :cpntNome='campo.inserirAqui.campoExtra.nome'
                      :cpntValue='campo.inserirAqui.campoExtra.valueNivel'
                      :cpntOptions='campo.inserirAqui.campoExtra.options'
                      :cpntKeyValue='campo.inserirAqui.campoExtra.keyValue'
                      :cpntKeyMostra='campo.inserirAqui.campoExtra.keyMostra'
                      :cpntAutoComplete='campo.inserirAqui.campoExtra.autocomplete'
                      :cpntDisabled='campo.inserirAqui.campoExtra.disabled'
                      :cpntMostrar='campo.inserirAqui.campoExtra.mostrar'
                      :cpntMensagem='campo.inserirAqui.campoExtra.mensagem'
                      :cpntOptionInicialNome='campo.inserirAqui.campoExtra.optionInicialNome'
                      :cpntOptionInicialValue='campo.inserirAqui.campoExtra.optionInicialValue'
                      :cpntMensagemTipo='campo.inserirAqui.campoExtra.mensagemTipo'
                      :cpntAddOption='campo.inserirAqui.campoExtra.addOption'
                      :cpntMultiple='campo.inserirAqui.campoExtra.multiple'
                      :cpntExplica='campo.inserirAqui.campoExtra.explica'
                      :cpntClassSelect='campo.inserirAqui.campoExtra.classSelect2'
                      :cpntTabIndex='campo.inserirAqui.campoExtra.tabIndex'

                      :cpntOnKeyPressEnter='campo.inserirAqui.campoExtra.onKeyPressEnter'
                      :cpntOnChange='campo.inserirAqui.campoExtra.onChange'
                      :cpntOnBlur='campo.inserirAqui.campoExtra.onBlur'
                      :ref='campo.inserirAqui.campoExtra.tipo'
                    ></RF-Select2>

                    <div v-if='campo.inserirAqui.campoExtra.tipo === "input"' style="display: inline-block; text-align: right; margin-top: 25px; padding-right: 10px;">
                      <span v-if="[ 'item', 'subitem' ].indexOf(campo.inserirAqui.value) !== -1">
                        {{ campo.inserirAqui[Object.keys(campo.inserirAqui).filter(item => campo.inserirAqui.value === item)].indice }} - 
                      </span>

                      <RF-Input style="width: 300px; margin-bottom: 0px;"
                        :data-time="time" 
                        :class='"rf-field-tamanho-" + (campo.inserirAqui.campoExtra.hasOwnProperty("tamanho") ? campo.inserirAqui.campoExtra.tamanho : 0) + " rf-field-campoExtra-" + campo.inserirAqui.value'

                        :cpntStatus='campo.inserirAqui.campoExtra.status'
                        :cpntId='campo.inserirAqui.campoExtra.id'
                        :cpntTabIndex='campo.inserirAqui.campoExtra.tabIndex'
                        :cpntClassDivField='campo.inserirAqui.campoExtra.classDivField'
                        :cpntNome='campo.inserirAqui.campoExtra.nome'
                        :cpntValue='campo.inserirAqui.campoExtra.value'
                        :cpntType='campo.inserirAqui.campoExtra.type'
                        :cpntAutoComplete='campo.inserirAqui.campoExtra.autocomplete'
                        :cpntMask='campo.inserirAqui.campoExtra.mask'
                        :cpntDisabled='campo.inserirAqui.campoExtra.disabled'
                        :cpntMostrar='campo.inserirAqui.campoExtra.mostrar'
                        :cpntAutoFocus='campo.inserirAqui.campoExtra.autofocus'
                        :cpntMensagem='campo.inserirAqui.campoExtra.mensagem'
                        :cpntMensagemTipo='campo.inserirAqui.campoExtra.mensagemTipo'
                        :cpntPlaceholder='campo.inserirAqui.campoExtra.placeholder'
                        :cpntExplica='campo.inserirAqui.campoExtra.explica'
                        :cpntMaxLength='campo.inserirAqui.campoExtra.maxLength'

                        :cpntOnChange='campo.inserirAqui.campoExtra.onChange'
                        :cpntOnBlur='campo.inserirAqui.campoExtra.onBlur'
                        :cpntOnKeyPressEnter='campo.inserirAqui.campoExtra.onKeyPressEnter'
                        :ref='campo.inserirAqui.campoExtra.tipo'
                      ></RF-Input>
                    </div>
                    <div v-else-if='campo.inserirAqui.campoExtra.tipo === "ckeditor"' style="width: 100%; margin-top: 25px;">
                      <RF-Ckeditor style="width: 100%; margin-bottom: 0px;"
                        :data-time="time" :class='"rf-field-tamanho-" + (campo.inserirAqui.campoExtra.hasOwnProperty("tamanho") ? campo.inserirAqui.campoExtra.tamanho : 0) + " rf-field-campoExtra-" + campo.inserirAqui.value'

                        :cpntStatus='campo.inserirAqui.campoExtra.status'
                        :cpntId='campo.inserirAqui.campoExtra.id'
                        :cpntClassDivField='campo.inserirAqui.campoExtra.classDivField'
                        :cpntNome='campo.inserirAqui.campoExtra.nome'
                        :cpntValue='campo.inserirAqui.campoExtra.value'
                        :cpntAutoComplete='campo.inserirAqui.campoExtra.autocomplete'
                        :cpntDisabled='campo.inserirAqui.campoExtra.disabled'
                        :cpntMostrar='campo.inserirAqui.campoExtra.mostrar'
                        :cpntMensagem='campo.inserirAqui.campoExtra.mensagem'
                        :cpntMensagemTipo='campo.inserirAqui.campoExtra.mensagemTipo'
                        :cpntConfig='campo.inserirAqui.campoExtra.config'
                        :cpntExplica='campo.inserirAqui.campoExtra.explica'
                        :cpntTabIndex='campo.inserirAqui.campoExtra.tabIndex'

                        :cpntOnChange='campo.inserirAqui.campoExtra.onChange'
                        :cpntOnBlur='campo.inserirAqui.campoExtra.onBlur'
                        :ref='campo.inserirAqui.campoExtra.tipo'
                      ></RF-Ckeditor>
                    </div>

                    <div v-else-if='campo.inserirAqui.campoExtra.tipo === "select2"' style="display: inline-block; width: 315px; text-align: center; margin-top: 25px;">
                      <RF-Select2 style="width: 100%; margin-bottom: 0px;"
                        :data-time="time" :class='"rf-field-tamanho-" + (campo.inserirAqui.campoExtra.hasOwnProperty("tamanho") ? campo.inserirAqui.campoExtra.tamanho : 0) + " rf-field-campoExtra-" + campo.inserirAqui.value'

                        :cpntStatus='campo.inserirAqui.campoExtra.status'
                        :cpntId='campo.inserirAqui.campoExtra.id'
                        :cpntClassDivField='campo.inserirAqui.campoExtra.classDivField'
                        :cpntNome='campo.inserirAqui.campoExtra.nome'
                        :cpntValue='campo.inserirAqui.campoExtra.value'
                        :cpntOptions='campo.inserirAqui.campoExtra.options'
                        :cpntKeyValue='campo.inserirAqui.campoExtra.keyValue'
                        :cpntKeyMostra='campo.inserirAqui.campoExtra.keyMostra'
                        :cpntAutoComplete='campo.inserirAqui.campoExtra.autocomplete'
                        :cpntDisabled='campo.inserirAqui.campoExtra.disabled'
                        :cpntMostrar='campo.inserirAqui.campoExtra.mostrar'
                        :cpntMensagem='campo.inserirAqui.campoExtra.mensagem'
                        :cpntOptionInicialNome='campo.inserirAqui.campoExtra.optionInicialNome'
                        :cpntOptionInicialValue='campo.inserirAqui.campoExtra.optionInicialValue'
                        :cpntMensagemTipo='campo.inserirAqui.campoExtra.mensagemTipo'
                        :cpntAddOption='campo.inserirAqui.campoExtra.addOption'
                        :cpntMultiple='campo.inserirAqui.campoExtra.multiple'
                        :cpntExplica='campo.inserirAqui.campoExtra.explica'
                        :cpntClassSelect='campo.inserirAqui.campoExtra.classSelect2'
                        :cpntTabIndex='campo.inserirAqui.campoExtra.tabIndex'

                        :cpntOnKeyPressEnter='campo.inserirAqui.campoExtra.onKeyPressEnter'
                        :cpntOnChange='campo.inserirAqui.campoExtra.onChange'
                        :cpntOnBlur='campo.inserirAqui.campoExtra.onBlur'
                        :ref='campo.inserirAqui.campoExtra.tipo'
                      ></RF-Select2>
                    </div>

                    <RF-Select2 v-if="campo.inserirAqui.hasOwnProperty('novaPagina')" style="margin-top: 27px; margin-bottom: 0px; width: 170px; text-align: center;"
                      :data-time="time" :class='"rf-field-tamanho-" + (campo.inserirAqui.novaPagina.hasOwnProperty("tamanho") ? campo.inserirAqui.novaPagina.tamanho : 0) + " rf-field-novaPagina-" + campo.inserirAqui.value'

                      :cpntStatus='campo.inserirAqui.novaPagina.status'
                      :cpntId='campo.inserirAqui.novaPagina.id'
                      :cpntClassDivField='campo.inserirAqui.novaPagina.classDivField'
                      :cpntNome='campo.inserirAqui.novaPagina.nome'
                      :cpntValue='campo.inserirAqui.novaPagina.value'
                      :cpntOptions='campo.inserirAqui.novaPagina.options'
                      :cpntKeyValue='campo.inserirAqui.novaPagina.keyValue'
                      :cpntKeyMostra='campo.inserirAqui.novaPagina.keyMostra'
                      :cpntAutoComplete='campo.inserirAqui.novaPagina.autocomplete'
                      :cpntDisabled='campo.inserirAqui.novaPagina.disabled'
                      :cpntMostrar='campo.inserirAqui.novaPagina.mostrar'
                      :cpntMensagem='campo.inserirAqui.novaPagina.mensagem'
                      :cpntOptionInicialNome='campo.inserirAqui.novaPagina.optionInicialNome'
                      :cpntOptionInicialValue='campo.inserirAqui.novaPagina.optionInicialValue'
                      :cpntMensagemTipo='campo.inserirAqui.novaPagina.mensagemTipo'
                      :cpntAddOption='campo.inserirAqui.novaPagina.addOption'
                      :cpntMultiple='campo.inserirAqui.novaPagina.multiple'
                      :cpntExplica='campo.inserirAqui.novaPagina.explica'
                      :cpntClassSelect='campo.inserirAqui.novaPagina.classSelect2'
                      :cpntTabIndex='campo.inserirAqui.novaPagina.tabIndex'

                      :cpntOnKeyPressEnter='campo.inserirAqui.novaPagina.onKeyPressEnter'
                      :cpntOnChange='campo.inserirAqui.novaPagina.onChange'
                      :cpntOnBlur='campo.inserirAqui.novaPagina.onBlur'
                      :ref='campo.inserirAqui.novaPagina.tipo'
                    ></RF-Select2>

                    <div style="text-align: center; margin-top: 15px; margin-bottom: 15px;">
                      <!-- <div class="rf-checkbox" v-if="index >= 2 && arrayModelo.length >= 2 && campo.inserirAqui.campoExtra.hasOwnProperty('novaPagina')" style="display: block; margin: 0px 0px 14px 0px;">
                        <input
                          type="checkbox"

                          :data-time='time'
                          :id='formulario1.id + "--novaPagina--" + index + "--novaPagina"' 
                          :checked='campo.inserirAqui.campoExtra.novaPagina'
                          @change='contratosModeloConteudoOnChange(!campo.inserirAqui.campoExtra.novaPagina, formulario1.id + "--novaPagina--" + index + "--novaPagina")'>
                        <label :for='formulario1.id + "--novaPagina--" + index + "--novaPagina"' 
                         style="margin-bottom: 0px; cursor: pointer;">Nova página</label>
                      </div> -->

                      <RF-Button 
                        :data-time='time'

                        :cpntId='formulario1.id + "0-bt-inserir"'
                        :cpntStatus='""' 
                        :cpntTipo='"texto"'
                        :cpntTexto='"Inserir"'
                        :cpntClass='[ "btn", "btn-primary" ]'

                        @onClickButton="contratosModeloConteudoInserir(index)"
                      ></RF-Button>
                      <RF-Button 
                        :data-time='time'

                        :cpntId='formulario1.id + "0-bt-cancelar"'
                        :cpntStatus='""' 
                        :cpntTipo='"texto"'
                        :cpntTexto='"Cancelar"'
                        :cpntClass='[ "btn", "btn-default", "btn-sm" ]'

                        @onClickButton="contratosModeloConteudoInserirAqui(index)"
                      ></RF-Button>
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </template>
        </div>
      </div>

      <RF-Dialog v-if="Object.keys(formulario1.field).length >= 1 && formulario1.field.hasOwnProperty('cabecalho') && formulario1.field.cabecalho.visualizar === true"
      :cpntStatus='""'
      :cpntLargura='"700px"'
      :cpntTitulo='"Cabeçalho para contrato"'

      :cpntOnFecharDialog='formulario1.field.visualizar.onClick'>
        <template slot="conteudo">
          <div style="width: 175px; margin: 0px auto; padding: 0px 10px; background: #e9e9e9; border: 1px solid #ccc; border-radius: 3px; padding: 10px;">
            <table style="text-align: left;">
              <tr>
                <td rowspan='5'>
                  <img :src='$store.state.logotipo' style="width: 140px;">
                </td>
              </tr>
            </table>
          </div>
        </template>
      </RF-Dialog>
    </template>

    <RF-Progress v-if="download !== null"
      :cpntProgres="download"
      :cpntHeight="'30px'"
    ></RF-Progress>    
  </div>
</template>

<style scoped>
  .rf-contrato-modelo {
    margin-bottom: 130px;
  }
    .rf-contrato-modelo > .rf-modelo-config {
      overflow: auto;
      position: fixed;
      top: 0px;
      width: 295px;
      height: 100vh;
      background: #f5f5f5;
      border: 1px solid #ccc;
      margin-left: -15px;
      z-index: 100;
    }
      .rf-contrato-modelo > .rf-modelo-config > div {
        text-align: center;
        padding: 0px 15px 15px 15px;
      }
      .rf-contrato-modelo > .rf-modelo-config > .rf-modelo-config-bts {
        background: #e9e9e9;
        border-bottom: 1px solid #ccc;
        padding: 110px 15px 15px 15px;
        margin-bottom: 25px;
        width: 100%;
        clear: both;
      }
        .rf-contrato-modelo > .rf-modelo-config > .rf-modelo-config-bts > button {
          margin: 0px 5px;
        }
    .rf-contrato-modelo > .rf-modelo-conteudo {
      width: 100%;
      padding-left: 295px;
    }
      .rf-contrato-modelo > .rf-modelo-conteudo > div {
        text-align: center;
      }

  /* CONFIGURÇAOES DO CONTEUDO DO MODELO */
  /* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
  .ctr-barra-opcoes {
    width: 900px;
    margin: 0px auto;
    background: #e9e9e9;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 5px 0px;

    margin-top: 10px;
    margin-bottom: 10px;

    -webkit-touch-callout: none;
    -webkit-user-select: none;
     -khtml-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
  }
    .ctr-barra-opcoes > div {
      margin: 0px 10px;
    }
      .ctr-barra-opcoes td.rf-checkbox > input + label:before {
        margin-right: 0px !important;
      }
  
  .rf-field-campoExtra-item,
  .rf-field-campoExtra-subitem,
  .rf-field-campoExtra-sumario {
    width: 330px;
    max-width: 330px;
    margin: 0px auto;
  }
  .ctr-barra-opcoes-button-campo-extra {
    vertical-align: 3px;
    padding-top: 15px;
    padding-bottom: 5px;
    margin: 0px !important;
  }
    .ctr-barra-opcoes-button-campo-extra > button {
      margin: 0px 5px;
    }

/* ------------------------------------------------------------------------------------------- */
.ctr-modelo-con {
  background: #e9e9e9;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  box-shadow: 0 1px 1px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12), 0 1px 5px 0 rgba(0,0,0,.2);
  min-height: 50px;
  margin-bottom: 15px;
} 
.ctr-modelo-con:not(:first-child) {
  margin-top: 20px;
}
  .ctr-modelo-con-info {
    width: 340px;
    text-align: right;

    float: right;
    margin-right: -10px;
    margin-top: -11px;
  }
    .ctr-modelo-con-info-acao {
      display: inline-block;
      cursor: help;
      font-size: var(--font-base-soma-12);
      font-weight: 600;

    }
    .ctr-modelo-con-info-bts {
      display: inline-block;

      text-align: center;
      border: 1px solid #ccc;
      background: #fff;
      padding: 5px;
      width: 80px;
      border-top-right-radius: 5px;
      border-bottom-left-radius: 5px;
    }
  .ctr-modelo-con-item {
    font-size: var(--font-base-soma-14);
    text-align: left;
  }
  .ctr-modelo-con-item-editar {
    text-align: left;
    margin: 0px auto;
  }
</style>

<style>
  .ctr-modelo-con-item-editar > table > tr > td > div {
    margin-bottom: 0px !important;
  }
    .ctr-modelo-con-item-editar > table > tr > td > div > input {
      border: 1px solid #cccccc !important;
    }

/* ------------------------------------------------------------------------------------------- */
  /* CONFIGURÇAOES DO CONTEUDO DO MODELO */
  /* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
  .ctr-barra-opcoes-campo-extra > div > input {
    border: 1px solid #cccccc !important;
  }
  .ctr-barra-opcoes-campo-extra > .rf-field-campoExtra-conteudo {
    width: 100%;
    margin: 0px auto;
    margin-bottom: 5px !important;
  }
  .button-acoes-conteudo-modelo {
    width: 30px;
    height: 25px;
    padding: 0px;
  }

  /* CONFIGURÇAOES DO CAMPO MODELO */
  /* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
  .rf-contrato-modelo > .rf-modelo-conteudo > div > div.rf-field-modelo {
    width: 220px;
    margin: 0px auto;
    display: block;
  }

  /* CONFIGURÇAOES DO CAMPO NOME */
  /* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=- */
  .rf-contrato-modelo > .rf-modelo-config > div > .rf-form > .rf-field-nome > input {
    border: 1px solid #ccc;
    border-radius: 3px;
  }

  /* CONFIGURÇAOES DO ULTIMO CAMPO DO FORMULARIO 1 */
  /* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=- */
  .rf-contrato-modelo > .rf-modelo-config > div > .rf-form > div:last-child {
    margin-right: 20px !important;
  }

  /* CONFIGURÇAOES DO CONTEUDO DO MODELO */
  /* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=- */
  .rf-contrato-modelo > .rf-modelo-conteudo > div > .rf-form > div {
    width: 100% !important;
    max-width: 100% !important;
  }

  /* CONFIGURAÇÕES DOS INPUTS DA TELA */
  /* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=- */
  .rf-contrato-modelo > .rf-modelo-config > div > .rf-form > div.rf-cabecalho-selecionado {
    width: 134px !important;
    margin-right: 5px !important;
  }

  /* CONFIGURAÇÕES DOS INPUTS DA TELA */
  /* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=- */
  .ctr-barra-opcoes-campo-extra > td > .rf-input-group > input {
    border: 1px solid #ccc;
    border-radius: 3px;
  }

  /* CONFIGURÇAOES DO ULTIMO CAMPO DO FORMULARIO 1 */
  /* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=- */
  .rf-contrato-modelo > .rf-modelo-config > div > .rf-form > div:first-child {
    margin-top: 20px !important;
  }
  .rf-contrato-modelo > .rf-modelo-config > div > .rf-form ~ .rf-buttons-form {
    width: 250px;
  }
</style>

<script>
  const rfProgress = () => import('@/components/rf-geral/progress/RF-Progress.vue')

  export default {
    components: {
      'RF-Progress': rfProgress,
      'RF-Input': () => import('@/components/rf-geral/input/RF-Input.vue'),
      'RF-Select2': () => import('@/components/rf-geral/select2/RF-Select2.vue'),
      'RF-Ckeditor': () => import('@/components/rf-geral/ckeditor/RF-Ckeditor.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        formulario1: {},
        modelos: [],
        diretorios: [],
        download: null,
        codigoRotinaFacil: {},

        layout: [
          { id: 'A4-Retrato', nome: 'A4-Retrato', title: 'O documento a partir daqui terá o Tamanho A4 (210x297mm) e a orientação Retrato' },
          { id: 'A4-Paisagem', nome: 'A4-Paisagem', title: 'O documento a partir daqui terá o Tamanho A4 (210x297mm) e a orientação Paisagem' }
          // { nome: 'A3-Retrato', title: 'O documento a partir daqui terá o Tamanho A3 (297x420mm) e a orientação Retrato' },
          // { nome: 'A3-Paisagem', title: 'O documento a partir daqui terá o Tamanho A3 (297x420mm) e a orientação Paisagem' }
        ],
        novoOption: {
          acao: 'barra-opcoes',
          value: null,
          editar: false,
          opcoes: [
            { index: 'item', disabled: false, nome: 'Item', component: 'input', title: 'Item do documento.' },
            { index: 'conteudo', disabled: false, nome: 'Conteúdo', component: 'ckeditor', title: 'Conteúdo do item ou do documento.' },
            { index: 'subitem', disabled: false, nome: 'Subitem', component: 'input', title: 'Item do documento.' },
            // { index: 'voltar-item', disabled: false, nome: 'Voltar Item', component: 'input', title: 'Voltar nivel de item.' },
            { index: 'sumario', disabled: false, nome: 'Sumário', component: 'input', title: 'O Sumário será inserido nesta posição do documento.' },
            { index: 'ini-numeracao', disabled: false, nome: 'Numeração (Iniciar aqui)', title: 'A numeração das páginas começará a partir daqui no documento.' },
            { index: 'layout', disabled: false, nome: 'Orien. e Tam. da Próx. Página', component: 'select2' }
          ]
        },
        arrayModelo: []
      }
    },
    mounted: function () {
      if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 26 ], null, [ 50 ], null, null, null, true) === true) {
        this.contratosModeloIniciar()
      }
    },
    methods: {
      contratosModeloIniciar: function () {
        // SETA O STATUS GERAL
        this.statusGeral = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA INICIAR O FORMULARIO
        this.contratosModeloFormularioIniciar()
      },
      contratosModeloFormularioIniciar: function () {
        var self = this

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.formulario1 = {
          status: 'carregando',
          id: 'form-contrato-modelo-1',
          field: {}
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        self.formulario1.field = {
          referencia: {
            tipo: 'select2',
            tamanho: 2,
            nome: 'Referência',
            value: '',
            keyMostra: [ 'nome' ],
            keyValue: 'id',
            apiEnv: 'ref_mod',
            onChange: self.contratosModeloOnChangeValue
          },
          modelo: {
            tipo: 'select2',
            tamanho: 2,
            nome: 'Modelo de contrato',
            keyMostra: [ 'nome' ],
            keyValue: 'id',
            value: '',
            optionInicialNome: '',
            apiEnv: 'id',
            apiRec: 'id',
            mostrar: false,
            disabled: self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(true, [ 26 ], null, [ 50 ], null, [ 546 ], null, false) === false,
            onChange: self.contratosModeloOnChangeValue
          },
          copiarModelo: {
            tipo: 'select2',
            tamanho: 2,
            nome: 'Copiar do modelo',
            keyMostra: [ 'nome' ],
            keyValue: 'id',
            value: '',
            optionInicialNome: 'Não',
            mostrar: false,
            onChange: self.contratosModeloOnChangeValue
          },
          nome: {
            tipo: 'input',
            tamanho: 2,
            nome: 'Nome',
            value: '',
            apiEnv: 'nome',
            apiRec: 'nome',
            mostrar: false,
            onChange: self.contratosModeloOnChangeValue
          },
          cofre: {
            tipo: 'select2',
            tamanho: 2,
            nome: 'Cofre D4Sign',
            value: '',
            keyMostra: [ 'dir_nome' ],
            keyValue: 'uuid',
            mostrar: false,
            onChange: self.contratosModeloOnChangeValue
          },
          pasta: {
            tipo: 'select2',
            tamanho: 2,
            nome: 'Pasta',
            value: '',
            optionInicialNome: 'Raiz',
            addOption: true,
            keyMostra: [ 'dir_nome' ],
            keyValue: 'uuid',
            mostrar: false,
            onChange: self.contratosModeloOnChangeValue
          },
          // aditivo: {
          //   tipo: 'select2',
          //   tamanho: 2,
          //   nome: 'Aditivo',
          //   value: 'n',
          //   optionInicialNome: '',
          //   keyMostra: [ 'nome' ],
          //   keyValue: 'id',
          //   options: [
          //     { id: 'n', nome: 'Não' },
          //     { id: 's', nome: 'Sim' }
          //   ],
          //   apiEnv: 'aditivo',
          //   apiRec: 'aditivo',
          //   mostrar: false,
          //   onChange: self.contratosModeloOnChangeValue
          // },
          cabecalho: {
            tipo: 'select2',
            tamanho: 2,
            nome: 'Utilizar o cabeçalho',
            value: 'cab1',
            keyMostra: [ 'nome' ],
            keyValue: 'id',
            options: [
              { id: 'cab1', nome: 'Modelo 1' }
            ],
            classDivField: [],
            visualizar: false,
            optionInicialNome: 'Não Utilizar',
            apiEnv: 'cabecalho',
            apiRec: 'cabecalho',
            mostrar: false,
            onChange: self.contratosModeloOnChangeValue
          },
          visualizar: {
            tamanho: 55,
            tipo: 'button',
            texto: 'Visualizar',
            mostrar: false,
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            onClick: function () {
              // SETA O NOVO VALOR
              self.formulario1.field.cabecalho.visualizar = !self.formulario1.field.cabecalho.visualizar

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            }
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // CRIA AS CHAVES PADROES DE TODOS OS COMPONENTS
        self.$store.state.FUN_CREATE_KEY_FIELDS(self.formulario1.field, function (fields) {
          // SETA OS CAMPOS RECEBIDOS
          self.formulario1.field = fields

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, nome: null, ref_mod: null }, where: { aAnd: [ { f: 'status', o: '=', v: '1' } ] } }

          self.$store.state.comunicaAPI('/contrato/modelo/get/', 'GET', queryGet, function (apiSuccess) {
            self.modelos = apiSuccess.data

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { uuid: null, uuid_pai: null, dir_nome: null }, where: { f: 'status', o: '=', v: '1' } }

            self.$store.state.comunicaAPI('/contrato/diretorio/get/', 'GET', queryGet, function (apiSuccess) {
              // SETA OS DIRETORIOS RECEBIDOS
              self.diretorios = apiSuccess.data

              // PEGA APENAS OS COFRES RETORNADOS
              self.formulario1.field.cofre.options = self.diretorios.filter(item => item.uuid_pai === '')

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              self.$store.state.comunicaAPI('/contrato/referencia/get', 'GET', null, function (apiSuccess) {
                // SETA OS VALORES RECEBIDOS
                self.formulario1.field.referencia.options = apiSuccess.data

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()

                // ADICIONA A OPÇÃO NOVO LAYOUT
                if (self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(true, [ 26 ], null, [ 50 ], null, [ 545 ], null, false) === true) {
                  self.formulario1.field.modelo.options.unshift({ id: '0', nome: 'Inserir Novo' })
                }

                // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES E DEPIOS FINALIZAR O FORMULARIO
                self.contratosModeloFinalizarForm()
              }, function (apiError) {
                self.contratosModeloSetaErroAPi(apiError)
              })
            }, function (apiError) {
              self.contratosModeloSetaErroAPi(apiError)
            })
          }, function (apiError) {
            self.contratosModeloSetaErroAPi(apiError)
          })
        })
      },
      contratosModeloFinalizarForm: function () {
        var self = this

        self.$store.state.FUN_CREATE_BUTTON_FORM(self.formulario1.id, [ 0 ], null, {
          env: self.contratosModeloEnviarAPi,
          ver: function (button) {
            self.contratosModeloVisualizar(button, self.formulario1.field.modelo.value)
          },
          copiar: self.contratosModeloCopiar,
          exc: self.contratosModeloExcluir
        }, function (buttons) {
          // CRIA OS BUTTONS DO FORMULARIO
          self.formulario1.buttons = buttons

          for (var key in self.formulario1.buttons) {
            self.formulario1.buttons[key].mostrar = false
          }

          // SETA O NOME DO BUTTON
          self.formulario1.buttons.copiar.texto = 'Copiar modelo'
          self.formulario1.buttons.copiar.class = [ 'btn', 'btn-primary', 'btn-sm' ]

          self.formulario1.buttons.ver.texto = 'Pré-Visualizar'
          self.formulario1.buttons.ver.class = [ 'btn', 'btn-warning', 'btn-sm' ]
          self.formulario1.ver = self.formulario1.buttons.ver
          delete self.formulario1.buttons.ver

          // SETA O NOME DO BUTTON
          self.formulario1.buttons.exc.texto = 'Excluir'
          if (self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(true, [ 26 ], null, [ 50 ], null, [ 547 ], null, false) === false) {
            delete self.formulario1.buttons.exc
          }

          // SETA O STATUS PARA O FORMULARIO
          self.formulario1.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          if (self.formulario1.field.modelo.value !== '0') {
            // // DESATIVA O CAMPO PARA ALTERAÇÃO
            // self.formulario1.field.aditivo.disabled = true

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA CARREGAR AS PASTA E DEPOIS FINALIZAR O FORMULARIO
            self.contratosModeloCarregarValores(function () {
              // EXECUTA FUNÇÃO PARA CARREGAR AS PASTAS
              self.contratosModeloCarregarPastas()
            })
          } else {
            // // ATIVA O CAMPO PARA ALTERAÇÃO
            // self.formulario1.field.aditivo.disabled = false

            // SETA O STATUS GERAL
            self.statusGeral = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA CARREGAR AS PASTA E DEPOIS FINALIZAR O FORMULARIO
            self.contratosModeloCarregarValores()
          }
        })
      },
      contratosModeloConteudo: function (index, data = []) {
        // LIMPA O VETOR DE DADOS
        this.arrayModelo = []

        var indicePadding = 0

        for (var key in data) {
          var campo = {
            id: data[key].id,
            indice: data[key].indice,
            acao: data[key].acao,
            np: data[key].nova_pagina,
            conteudo: data[key].conteudo,
            inserirAqui: false,
            editar: false,
            campoExtra: {
              id: this.formulario1.id + '--editar-opcoes-' + data[key].acao + '--' + data[key].id + '--' + 'campoExtra',
              status: '',
              nome: '',
              value: '',
              mostrar: true,
              mensagem: '',
              mensagemTipo: '',
              onChange: this.contratosModeloConteudoOnChange
            }
          }

          switch (data[key].acao) {
            case 'item':
            case 'subitem':
            case 'voltar-item':
              campo.campoExtra.tipo = 'input'
              campo.campoExtra.novaPagina = false

              indicePadding = (data[key].indice.split('.').length - 1)
              break

            case 'sumario':
              campo.campoExtra.tipo = 'input'
              campo.campoExtra.novaPagina = false
              break

            case 'conteudo':
              campo.campoExtra.tipo = 'ckeditor'
              campo.campoExtra.novaPagina = false
              campo.campoExtra.config = {
                extraPlugins: 'codigoRotinaFacil',
                removeButtons: 'Flash,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Undo,Find,SelectAll,Scayt,Replace,Redo,Form,TextField,Radio,Textarea,Select,Button,ImageButton,Subscript,Superscript,CopyFormatting,Outdent,Indent,Blockquote,CreateDiv,BidiLtr,BidiRtl,Language,Anchor,Image,Styles,Format,ShowBlocks,About,Checkbox,HiddenField',
                toolbarGroups: [
                  { name: 'tools', groups: [ 'tools' ] },
                  { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
                  { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                  { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
                  { name: 'forms', groups: [ 'forms' ] },
                  { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                  { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
                  { name: 'links', groups: [ 'links' ] },
                  { name: 'insert', groups: [ 'insert' ] },
                  { name: 'styles', groups: [ 'styles' ] },
                  { name: 'colors', groups: [ 'colors' ] },
                  { name: 'others', groups: [ 'others' ] },
                  { name: 'about', groups: [ 'about' ] },
                  { name: 'codigoRotinaFacil', groups: [ 'codigoRotinaFacil' ] }
                ],
                height: '250'
              }
              break

            case 'ini-numeracao':
              campo.campoExtra.novaPagina = false
              break

            case 'layout':
              campo.campoExtra.tipo = 'select2'
              campo.campoExtra.keyValue = 'nome'
              campo.campoExtra.keyMostra = [ 'nome' ]
              campo.campoExtra.options = this.layout
              campo.campoExtra.value = '0'
              break
          }

          campo.indicePadding = indicePadding

          campo.novaPagina = {
            tipo: 'select2',
            status: '',
            id: this.formulario1.id + '--editar-novaPagina--' + key + '--' + 'novaPagina',
            nome: 'Nova página',
            value: data[key].nova_pagina,
            mostrar: true,
            mensagem: '',
            mensagemTipo: '',
            options: this.layout,
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            onChange: this.contratosModeloConteudoOnChange
          }

          if (key !== '0' && campo.novaPagina.options.filter(item => item.id === 'n').length === 0) {
            campo.novaPagina.options.unshift({ id: 'n', nome: 'Não', title: '' })
          }

          this.arrayModelo.push(campo)
        }

        if (index === 'all') {
          if (this.arrayModelo.length >= 2) {
            this.formulario1.ver.mostrar = true
          } else {
            this.formulario1.ver.mostrar = false
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      contratosModeloCarregarPastas: function () {
        var self = this

        // LIMPA OS OPTIONS EXISTENTE PARA ESTA PASTA
        self.formulario1.field.pasta.options = []

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        if (self.formulario1.field.cofre.value !== '') {
          // LIMPA OS OPTIONS EXISTENTE PARA ESTA PASTA
          self.formulario1.field.pasta.status = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // SETA OS VALORES RECEBIDOS
          self.formulario1.field.pasta.options = self.diretorios.filter(item => item.uuid_pai === self.formulario1.field.cofre.value)

          // LIMPA OS OPTIONS EXISTENTE PARA ESTA PASTA
          self.formulario1.field.pasta.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // VERIFICA QUAL É O CAMPOS QUE DEVE SER MOSTRADO
          self.contratosModeloVerificaCampoMostra()

          // SETA O STATUS DA TELA
          self.statusGeral = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        } else {
          // SETA O STATUS DA TELA
          self.statusGeral = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // VERIFICA QUAL É O CAMPOS QUE DEVE SER MOSTRADO
          self.contratosModeloVerificaCampoMostra()
        }
      },
      contratosModeloVerificaCampoMostra: function () {
        var self = this

        // VERIFICA SE DEVE APRESENTAR O BOTÃO EXCLUIR
        if (self.formulario1.buttons.hasOwnProperty('exc') && self.formulario1.field.referencia.value !== '0' && [ '', '0' ].indexOf(self.formulario1.field.modelo.value) === -1) {
          self.formulario1.buttons.exc.mostrar = true

          if (self.formulario1.hasOwnProperty('ver')) {
            if (self.arrayModelo.length >= 2) {
              self.formulario1.ver.mostrar = true
            } else {
              self.formulario1.ver.mostrar = false
            }
          }
        } else if (self.formulario1.buttons.hasOwnProperty('exc') || self.formulario1.hasOwnProperty('ver')) {
          if (self.formulario1.buttons.hasOwnProperty('exc')) {
            self.formulario1.buttons.exc.mostrar = false
          }

          if (self.formulario1.hasOwnProperty('ver')) {
            self.formulario1.ver.mostrar = [ '', '0' ].indexOf(self.formulario1.field.modelo.value) === -1
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // ADICIONA O PRIMIEIRO OPTION DO SELECT2 COFRE
        if ([ '', '0' ].indexOf(self.formulario1.field.modelo.value) === -1) {
          if (self.formulario1.field.cofre.value !== '') {
            self.formulario1.field.pasta.optionInicialNome = 'Raiz'
          } else {
            self.formulario1.field.pasta.optionInicialNome = 'Selecione um cofre.'
          }
        }

        // VERIFICA SE DEVE APRESENTAR O BOTÃO EXCLUIR
        if ([ '', null ].indexOf(self.formulario1.field.modelo.value) === -1 && self.formulario1.field.cabecalho.value !== '') {
          self.formulario1.field.visualizar.mostrar = true
          self.formulario1.field.cabecalho.classDivField = [ 'rf-cabecalho-selecionado' ]
        } else {
          self.formulario1.field.visualizar.mostrar = false
          self.formulario1.field.cabecalho.classDivField = []
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()
      },
      contratosModeloOnChangeValue: function (value, id) {
        var self = this

        var form = 'formulario' + id.substring((self.formulario1.id.length), (self.formulario1.id.length - 1))

        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.substring((self[form].id.length + 1), id.length)

        // SETA O VALOR RECEBIDO
        self[form].field[index].value = value

        // REMOVE A MENSAGEM DE ERRO
        self[form].field[index].mensagem = ''
        self[form].field[index].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        switch (index) {
          case 'copiarModelo':
            switch (value) {
              case '':
                // SETA SE O BOTÃO É VISIVEL OU NÃO
                self.formulario1.buttons.copiar.mostrar = false

                // FAZ A FUNÇÃO ONCHANGE DO MODELO
                self.contratosModeloOnChangeValue(self.formulario1.field.modelo.value, self.formulario1.field.modelo.id)
                break

              default:
                self.arrayModelo = []

                for (key in self.formulario1.field) {
                  if ([ 'referencia', 'modelo', 'copiarModelo' ].indexOf(key) === -1) {
                    self.formulario1.field[key].mostrar = false
                  }
                }

                for (key in self.formulario1.buttons) {
                  if ([ 'copiar' ].indexOf(key) === -1) {
                    self.formulario1.buttons[key].mostrar = false
                  }
                }

                // SETA SE O BOTÃO É VISIVEL OU NÃO
                self.formulario1.buttons.copiar.mostrar = true
                break
            }
            break

          case 'modelo':
            var key = ''
            if (value !== '' && value !== null) {
              for (key in self.formulario1.field) {
                if ([ 'referencia', 'modelo', 'visualizar', 'copiarModelo' ].indexOf(key) === -1) {
                  self.formulario1.field[key].mostrar = true
                }
              }

              self.contratosModeloCarregarConteudo()
            } else {
              self.arrayModelo = []

              for (key in self.formulario1.field) {
                if ([ 'referencia', 'modelo' ].indexOf(key) === -1) {
                  self.formulario1.field[key].mostrar = false
                }
              }
            }

            // VERIFICA SE DEE ATIVAR O CAMPO
            if (value !== '0') {
              // self.formulario1.field.aditivo.disabled = true

              // SETA O NOME DO BUTTON
              self.formulario1.buttons.env.texto = 'Atualizar'

              self.formulario1.buttons.copiar.mostrar = false
              self.formulario1.field.copiarModelo.mostrar = false
              self.formulario1.field.copiarModelo.value = ''
            } else {
              // self.formulario1.field.aditivo.disabled = false

              // SETA O NOME DO BUTTON
              self.formulario1.buttons.env.texto = 'Inserir'

              // self.formulario1.buttons.copiar.mostrar = true
              self.formulario1.buttons.env.mostrar = true
              self.formulario1.field.copiarModelo.mostrar = true
              self.formulario1.field.copiarModelo.value = ''
            }

            for (var chave in self.formulario1.buttons) {
              if ([ 'copiar' ].indexOf(chave) === -1) {
                self.formulario1.buttons[chave].mostrar = value !== ''
              }
            }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA BUSCAR OS CODIGOS ROTINA FACIL
            self.contratosModeloBuscarCodigoRotinaFacil(self.contratosModeloCarregarValores)
            break

          case 'referencia':
            // CARREGA OS MODELOS DA REFERENCIA SELECIONADA
            self.formulario1.field.modelo.options = self.modelos.filter(item => item.ref_mod === value)
            self.formulario1.field.copiarModelo.options = self.modelos.filter(item => item.ref_mod === value)

            if (value !== '') {
              self.formulario1.field.modelo.mostrar = true
              self.formulario1.field.modelo.value = ''

              // ADICIONA A OPÇÃO NOVO LAYOUT
              if (self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(true, [ 26 ], null, [ 50 ], null, [ 545 ], null, false) === true) {
                self.formulario1.field.modelo.options.unshift({ id: '0', nome: 'Inserir Novo' })
              }

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              // FAZ A FUNÇÃO ONCHANGE DO MODELO
              self.contratosModeloOnChangeValue('', self.formulario1.field.copiarModelo.id)
            } else {
              // OCULTA O CAMPO DO MODELO
              self.formulario1.field.modelo.mostrar = false

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              // LIMPA OS CONTEUDOS DO MODELO
              self.arrayModelo = []

              for (key in self.formulario1.field) {
                if ([ 'referencia' ].indexOf(key) === -1) {
                  self.formulario1.field[key].mostrar = false
                }
              }

              for (key in self.formulario1.buttons) {
                if ([ '' ].indexOf(key) === -1) {
                  self.formulario1.buttons[key].mostrar = false
                }
              }

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            }
            break

          case 'cofre':
            // CHAMA A FUNÇÃO PARA CARREGAR AS PASTA
            self.contratosModeloCarregarPastas()
            break

          case 'cabecalho':
            self.contratosModeloVerificaCampoMostra()
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()
      },
      contratosModeloCarregarConteudo: function () {
        var self = this

        if ([ '', '0' ].indexOf(self.formulario1.field.modelo.value) === -1) {
          // LIMPA O VETOR DE DADOS
          self.arrayModelo = []

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, acao: null, conteudo: null, indice: null, nova_pagina: null, posicao: null, status: null }, where: { aAnd: [ { f: 'id_ctr_mod', o: '=', v: self.formulario1.field.modelo.value }, { f: 'status', o: '=', v: '1' } ] }, order: { posicao: 'asc' } }

          self.$store.state.comunicaAPI('/contrato/modelo/conteudo/get/', 'GET', queryGet, function (apiSuccess) {
            // ADICIONA O VALOR EM BRANCO
            apiSuccess.data.unshift({})

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA CRIAR OS CAMPOS
            self.contratosModeloConteudo('all', apiSuccess.data)
          }, function (apiError) {
            self.contratosModeloSetaErroAPi(apiError)
          })
        } else {
          // LIMPA O VETOR DE DADOS
          self.arrayModelo = []

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        }
      },
      contratosModeloCarregarValores: function (callback = null) {
        var self = this

        // VERIFICA QUAL É O CAMPOS QUE DEVE SER MOSTRADO
        self.contratosModeloVerificaCampoMostra(true)

        if (callback === null) {
          callback = self.contratosModeloVerificaCampoMostra
        }

        // VERIFICA SE DEVE CARREGAR OS VALORES
        if ([ '', '0', null ].indexOf(self.formulario1.field.modelo.value) === -1) {
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, nome: null, ref_mod: null, uuid_dir_pdr: null, aditivo: null, cabecalho: null }, where: { f: 'id', o: '=', v: self.formulario1.field.modelo.value } }

          self.$store.state.comunicaAPI('/contrato/modelo/get/', 'GET', queryGet, function (apiSuccess) {
            self.$store.state.FUN_API_RET_SET_VALUE(self.formulario1, apiSuccess.data[0], function (form) {
              // SETA OS CAMPOS RECEBIDOS
              self.formulario1 = form

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              var diretorio = self.diretorios.filter(item => item.uuid === apiSuccess.data[0].uuid_dir_pdr || item.uuid_pai === apiSuccess.data[0].uuid_dir_pdr)

              // SETA VALOR DO COFRE
              if (diretorio.length >= 1) {
                diretorio = diretorio[0]

                if (diretorio.uuid_pai !== '') {
                  self.formulario1.field.cofre.value = diretorio.uuid_pai
                  self.formulario1.field.pasta.value = diretorio.uuid
                } else {
                  self.formulario1.field.cofre.value = diretorio.uuid
                }
              }

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              // VERIFICA QUAL É O CAMPOS QUE DEVE SER MOSTRADO
              self.contratosModeloVerificaCampoMostra(false)

              // CHAMA A FUNÇÃO PARA CARREGAR AS PASTAS
              self.contratosModeloCarregarPastas()

              // CHAMA A FUNÇÃO CALLBACK
              callback()
            })
          }, function (apiError) {
            self.contratosModeloSetaErroAPi(apiError)
          })
        } else if (callback !== null) {
          var key = ''

          // LIMPA OS VALORES DIGITADOS
          for (key in self.formulario1.field) {
            switch (key) {
              case 'modelo':
              case 'referencia':
                break

              // case 'aditivo':
              //   self.formulario1.field[key].value = 'n'
              //   break

              case 'nome':
              case 'cofre':
              case 'pasta':
                self.formulario1.field[key].value = ''
                break
            }
          }

          callback()
        }
      },
      contratosModeloEnviarAPi: function (button) {
        var self = this

        // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
        self.formulario1.buttons.env.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // MONTA O FORMULARIO PARA ENVIO A API
        self.$store.state.FUN_CREATE_FORM_API_FORMULARIO(self.formulario1.field, {}, function (formData) {
          if ([ '', '0' ].indexOf(formData.id) !== -1) {
            delete formData.id
          }

          // VERIFICA QUAL É A CHAVE QUE DEVE INFORMAR
          if (self.formulario1.field.pasta.value !== '') {
            formData.uuid_dir_pdr = self.formulario1.field.pasta.value
          } else {
            formData.uuid_dir_pdr = self.formulario1.field.cofre.value
          }
          formData.aditivo = 'n'

          self.$store.state.comunicaAPI('/contrato/modelo', (!formData.hasOwnProperty('id') ? 'POST' : 'PUT'), formData, function (apiSuccess) {
            switch (button) {
              case 'ver':
                self.contratosModeloAbrir(apiSuccess.ref.id, function () {
                  // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
                  self.formulario1.buttons.env.status = ''

                  // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                  self.time = new Date().getTime()

                  // CHAMA A FUNÇÃO PARA CARREGAR A PRE-VISUALIZAÇÃO
                  self.contratosModeloVisualizar(null, apiSuccess.ref.id)
                })
                break

              default:
                self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
                  if (apiSuccess.hasOwnProperty('ref') && apiSuccess.ref.hasOwnProperty('id') && apiSuccess.ref.id !== self.formulario1.field.modelo.value) {
                    self.contratosModeloAbrir(apiSuccess.ref.id, function () {
                      // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
                      self.formulario1.buttons.env.status = ''

                      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                      self.time = new Date().getTime()
                    })
                  } else {
                    // SETA O STATUS DA TELA
                    self.statusGeral = 'carregando'

                    self.contratosModeloAbrir(formData.id, function () {
                      // SETA O STATUS DA TELA
                      self.statusGeral = ''

                      // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
                      self.formulario1.buttons.env.status = ''

                      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                      self.time = new Date().getTime()
                    })
                  }
                })
                break
            }
          }, function (apiError) {
            self.contratosModeloSetaErroAPi(apiError)
          }, function (apiValid, apiStatus) {
            self.$store.state.FUN_API_RET_VALIDA(self, 'formulario1', apiValid, apiStatus, self.formulario1.field, true, function (form) {
              // SETA OS CAMPOS COM OS ERROS
              self.formulario1.field = form

              // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
              self.formulario1.buttons.env.status = ''

              // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
              self.formulario1.ver.status = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            })
          })
        }, false)
      },
      contratosModeloVisualizar: function (button, idMod) {
        var self = this

        // // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
        self.formulario1.ver.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // VERIFICA SE DEVE SALVAR PRIMEIRO ANTES DE ABRIR O ARQUIVO
        if (button === 'ver' && self.formulario1.field.modelo.value === '0') {
          self.contratosModeloEnviarAPi(button)
        } else {
          // MONTA O FORMULARIO PARA ENVIO A API
          self.$store.state.comunicaAPI('/contrato/modelo/pre-visualizar/get/', 'GET', idMod, function (apiSuccess) {
            // const url = window.URL.createObjectURL(new Blob([response.data]));
            // const link = document.createElement('a')
            // link.href = window.URL.createObjectURL(new Blob([apiSuccess]))
            // link.setAttribute('download', 'file.pdf') // or any other extension
            // document.body.appendChild(link)
            // link.click()

            // FECHA A BARRA DE PROGRESSO
            self.download = null

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // ABRE O CONTEUDO EM UMA NOVA ABA
            setTimeout(function () {
              // ABRE O ARQUIVO EM UMA NOVA ABA
              self.$store.state.WEB_WINDOW_OPEN(window.URL.createObjectURL(new Blob([apiSuccess], { type: 'application/pdf' })), '_blank')

              // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
              self.formulario1.buttons.env.status = ''

              // // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
              self.formulario1.ver.status = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            }, 500)
          }, function (apiError) {
            self.contratosModeloSetaErroAPi(apiError)
          }, null, null, {
            tipo: 'blob',
            callback: function (progress) {
              self.download = progress
            }
          })
        }
      },
      contratosModeloCopiar: function () {
        var self = this

        // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
        self.formulario1.buttons.copiar.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // MONTA O FORMULARIO PARA API
        var formData = {
          ref_mod: self.formulario1.field.referencia.value,
          id_ctr_mod: self.formulario1.field.copiarModelo.value
        }

        // MONTA O FORMULARIO PARA ENVIO A API
        self.$store.state.comunicaAPI('/contrato/modelo/copiar', 'POST', formData, function (apiSuccess) {
          self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
            self.contratosModeloAbrir(apiSuccess.ref.id)
          })
        }, function (apiError) {
          if (apiError.cod.toString() !== '406') {
            self.contratosModeloSetaErroAPi(apiError)
          } else {
            // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
            self.formulario1.buttons.copiar.status = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }
        })
      },
      contratosModeloExcluir: function () {
        if (window.confirm('Deseja realmente excluir o(s) modelo(s) de contrato selecionado(s)?')) {
          var self = this

          // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
          self.formulario1.buttons.exc.status = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // MONTA O FORMULARIO PARA API
          var formData = {
            id: self.formulario1.field.modelo.value
          }

          // MONTA O FORMULARIO PARA ENVIO A API
          self.$store.state.comunicaAPI('/contrato/modelo', 'DELETE', formData, function (apiSuccess) {
            self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
              self.contratosModeloAbrir('')
            })
          }, function (apiError) {
            if (apiError.cod.toString() !== '406') {
              self.contratosModeloSetaErroAPi(apiError)
            } else {
              // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
              self.formulario1.buttons.exc.status = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            }
          })
        }
      },
      contratosModeloSetaErroAPi: function (apiError) {
        // SETA O STATUS PARA O FORMULARIO
        this.statusGeral = apiError

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      contratosModeloBuscarCodigoRotinaFacil: function (callback = null) {
        var self = this

        if (self.formulario1.field.referencia.value !== '') {
          // MONTA O FORMULARIO PARA ENVIO A API
          self.$store.state.comunicaAPI('/contrato/referencia/crf/get/', 'GET', self.formulario1.field.referencia.value, function (apiSuccess) {
            // SETA OS CODIGOS ROTINA FÁCIL
            window.codigoRotinaFacil = apiSuccess.data

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            if (callback !== null) {
              callback()
            }
          }, function (apiError) {
            self.contratosModeloSetaErroAPi(apiError)
          })
        } else if (callback !== null) {
          callback()
        }
      },
      contratosModeloConteudoOnChange: function (value, id) {
        var self = this

        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')

        switch (index[1]) {
          case 'barra-opcoes':
            // SETA O NOVO VALOR DO CAMPO
            self.arrayModelo[index[2]].inserirAqui.value = value

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            var campoExtra = {
              status: '',
              id: self.formulario1.id + '--' + index[1] + '-' + value + '--' + index[2] + '--' + 'campoExtra',
              nome: '',
              value: '',
              mostrar: true,
              mensagem: '',
              mensagemTipo: '',
              onChange: self.contratosModeloConteudoOnChange
            }

            switch (value) {
              case 'item':
              case 'subitem':
              case 'sumario':
                campoExtra.tipo = 'input'

                // VERIFICA SE DEVE TER A OPÇÃO DE NOVA PAGINA
                if (index[2] !== '0') {
                  campoExtra.novaPagina = false
                }
                break

              case 'conteudo':
                campoExtra.tipo = 'ckeditor'

                campoExtra.config = {
                  extraPlugins: 'codigoRotinaFacil',
                  removeButtons: 'Flash,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Undo,Find,SelectAll,Scayt,Replace,Redo,Form,TextField,Radio,Textarea,Select,Button,ImageButton,Subscript,Superscript,CopyFormatting,Outdent,Indent,Blockquote,CreateDiv,BidiLtr,BidiRtl,Language,Anchor,Image,Styles,Format,ShowBlocks,About,Checkbox,HiddenField',
                  toolbarGroups: [
                    { name: 'tools', groups: [ 'tools' ] },
                    { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
                    { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                    { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
                    { name: 'forms', groups: [ 'forms' ] },
                    { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                    { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
                    { name: 'links', groups: [ 'links' ] },
                    { name: 'insert', groups: [ 'insert' ] },
                    { name: 'styles', groups: [ 'styles' ] },
                    { name: 'colors', groups: [ 'colors' ] },
                    { name: 'others', groups: [ 'others' ] },
                    { name: 'about', groups: [ 'about' ] },
                    { name: 'codigoRotinaFacil', groups: [ 'codigoRotinaFacil' ] }
                  ],
                  height: '250'
                }

                // VERIFICA SE DEVE TER A OPÇÃO DE NOVA PAGINA
                if (index[2] !== '0') {
                  campoExtra.novaPagina = false
                }
                break

              case 'voltar-item':
                campoExtra.tipo = 'input'

                // VERIFICA SE DEVE TER A OPÇÃO DE NOVA PAGINA
                if (index[2] !== '0') {
                  campoExtra.novaPagina = false
                }

                campoExtra.valueNivel = ''
                campoExtra.options = self.arrayModelo[index[2]].inserirAqui['voltar-item'].opt
                campoExtra.keyValue = 'recuo'
                campoExtra.keyMostra = [ 'indice' ]
                break
            }

            // SETA SE DEVE ABRIR O CAMPO DE EDITAR
            self.arrayModelo[index[2]].inserirAqui.editar = value !== ''

            // LIMPA OS CAMPOS EXTRAS EXISTENTES
            self.arrayModelo[index[2]].inserirAqui.campoExtra = campoExtra

            self.arrayModelo[index[2]].inserirAqui.novaPagina = {
              tipo: 'select2',
              status: '',
              id: self.formulario1.id + '--novaPagina--' + index[2] + '--' + 'novaPagina',
              nome: 'Nova página',
              value: 'n',
              mostrar: true,
              mensagem: '',
              mensagemTipo: '',
              options: self.layout,
              keyValue: 'id',
              keyMostra: [ 'nome' ],
              onChange: self.contratosModeloConteudoOnChange
            }
            if (index[2] !== '0' && self.arrayModelo[index[2]].inserirAqui.novaPagina.options.filter(item => item.id === 'n').length === 0) {
              self.arrayModelo[index[2]].inserirAqui.novaPagina.options.unshift({ id: 'n', nome: 'Não', title: '' })
            } else if (index[2] === '0') {
              self.arrayModelo[index[2]].inserirAqui.novaPagina.value = 'A4-Retrato'
            }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA DAR FOCUS NO CAMPO
            self.contratosModeloFocusCampo(campoExtra.tipo, campoExtra.id)
            break

          case 'barra-opcoes-item':
          case 'barra-opcoes-conteudo':
          case 'barra-opcoes-subitem':
          case 'barra-opcoes-sumario':
          case 'barra-opcoes-layout':
            // SETA O NOVO VALOR RECEBIDO
            self.arrayModelo[index[2]].inserirAqui.campoExtra.value = value

            // REMOVE AS VALIDAÇÕES DA API APÓS ATUALIZAR O VALOR
            self.arrayModelo[index[2]].inserirAqui.campoExtra.mensagem = ''
            self.arrayModelo[index[2]].inserirAqui.campoExtra.mensagemTipo = ''
            break

          case 'barra-opcoes-voltar-item':
            if (index[3] === 'campoExtra-recuo') {
              // SETA O NOVO VALOR RECEBIDO
              self.arrayModelo[index[2]].inserirAqui.campoExtra.valueNivel = value

              // REMOVE AS VALIDAÇÕES DA API APÓS ATUALIZAR O VALOR
              self.arrayModelo[index[2]].inserirAqui.campoExtra.mensagem = ''
              self.arrayModelo[index[2]].inserirAqui.campoExtra.mensagemTipo = ''
            } else if (index[3] === 'campoExtra') {
              // SETA O NOVO VALOR RECEBIDO
              self.arrayModelo[index[2]].inserirAqui.campoExtra.value = value

              // REMOVE AS VALIDAÇÕES DA API APÓS ATUALIZAR O VALOR
              self.arrayModelo[index[2]].inserirAqui.campoExtra.mensagem = ''
              self.arrayModelo[index[2]].inserirAqui.campoExtra.mensagemTipo = ''
            }
            break

          case 'novaPagina':
            // SETA O NOVO VALOR RECEBIDO
            self.arrayModelo[index[2]].inserirAqui.novaPagina.value = value

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
            break

          case 'editar-opcoes-item':
          case 'editar-opcoes-conteudo':
          case 'editar-opcoes-subitem':
          case 'editar-opcoes-sumario':
          case 'editar-opcoes-layout':
            var indexLin = self.arrayModelo.findIndex(item => item.hasOwnProperty('id') && item.id === index[2])

            if (indexLin !== -1) {
              // SETA O NOVO VALOR RECEBIDO
              self.arrayModelo[indexLin][index[3]].value = value

              // REMOVE AS VALIDAÇÕES DA API APÓS ATUALIZAR O VALOR
              self.arrayModelo[indexLin][index[3]].mensagem = ''
              self.arrayModelo[indexLin][index[3]].mensagemTipo = ''
            }
            break
          case 'editar-novaPagina':
            // SETA O NOVO VALOR RECEBIDO
            self.arrayModelo[index[2]].novaPagina.value = value

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
            break
        }
      },
      contratosModeloConteudoCalcItem: function (index) {
        // SETA O VALOR QUE SERÁ RETORNADO
        var retorno = 0

        for (var key in this.arrayModelo) {
          if (this.arrayModelo[key].acao === 'item') {
            retorno += 1

            if (index.toString() === key.toString()) {
              break
            }
          }
        }

        return retorno
      },
      contratosModeloConteudoExcluir: function (id) {
        if (window.confirm('Deseja realmente excluir este registro?')) {
          var self = this

          var scroll = $(window).scrollTop()

          // MONTA O FORMULARIO PARA API
          var formData = {
            id: id
          }

          // MONTA O FORMULARIO PARA ENVIO A API
          self.$store.state.comunicaAPI('/contrato/modelo/conteudo', 'DELETE', formData, function (apiSuccess) {
            self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
              // CHAMA A FUNÇÃO PARA CARREGAR O CONTEUDO DO MODELO
              self.contratosModeloCarregarConteudo()

              // CHAMA A FUNÇÃO PARA DAR SCROLL NA PAGINA NO LOCAL INICIAL
              self.contratosModeloScrollPosition(scroll)
            })
          }, function (apiError) {
            if (apiError.cod.toString() !== '406') {
              self.contratosModeloSetaErroAPi(apiError)
            }
          })
        }
      },
      contratosModeloConteudoAtaulizar: function (id, index) {
        var self = this

        var scroll = $(window).scrollTop()

        var formData = {
          id: id,
          conteudo: self.arrayModelo[index].campoExtra.value
        }

        if (self.arrayModelo[index].campoExtra.hasOwnProperty('novaPagina')) {
          formData.nova_pagina = self.arrayModelo[index].novaPagina.value // === true ? 's' : 'n'
        }

        // MONTA O FORMULARIO PARA ENVIO A API
        self.$store.state.comunicaAPI('/contrato/modelo/conteudo', 'PUT', formData, function (apiSuccess) {
          self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
            // CHAMA A FUNÇÃO PARA CARREGAR O CONTEUDO DO MODELO
            self.contratosModeloCarregarConteudo()

            // CHAMA A FUNÇÃO PARA DAR SCROLL NA PAGINA NO LOCAL INICIAL
            self.contratosModeloScrollPosition(scroll)
          })
        }, function (apiError) {
          self.contratosModeloSetaErroAPi(apiError)
        }, function (apiValid, apiStatus) {
          self.$store.state.FUN_API_RET_VALIDA(self, '', apiValid, apiStatus, {}, true, function () {
          })
        })
      },
      contratosModeloConteudoInserir: function (posicao) {
        var self = this

        var scroll = $(window).scrollTop()

        var formData = {
          id_ctr_mod: self.formulario1.field.modelo.value,
          posicao: posicao,
          nova_pagina: 'n'
        }

        formData.acao = self.arrayModelo[posicao].inserirAqui.value

        // SETA O CONTEUDO DIGITADO
        if ([ 'layout', 'conteudo', 'item', 'voltar-item', 'subitem', 'sumario' ].indexOf(formData.acao) !== -1) {
          formData.conteudo = self.arrayModelo[posicao].inserirAqui.campoExtra.value
        }

        // VERIFICA SE DEVE INFORMAR SE É EM UMA NOVA PAGINA
        if (self.arrayModelo[posicao].inserirAqui.hasOwnProperty('novaPagina')) {
          formData.nova_pagina = self.arrayModelo[posicao].inserirAqui.novaPagina.value
        }

        if (formData.acao === 'voltar-item') {
          formData.recuo = self.arrayModelo[posicao].inserirAqui.campoExtra.valueNivel
        }

        self.$store.state.comunicaAPI('/contrato/modelo/conteudo', 'POST', formData, function (apiSuccess) {
          self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
            // CHAMA A FUNÇÃO PARA CARREGAMENTO DO CONTEUDO NOVAMENTE
            self.contratosModeloCarregarConteudo()

            // CHAMA A FUNÇÃO PARA DAR SCROLL NA PAGINA NO LOCAL INICIAL
            self.contratosModeloScrollPosition(scroll)
          })
        }, function (apiError) {
          self.contratosModeloSetaErroAPi(apiError)
        }, function (apiValid, apiStatus) {
          self.$store.state.FUN_API_RET_VALIDA(self, '', apiValid, apiStatus, {}, true, function () {
          })
        })
      },
      contratosModeloConteudoInserirAqui: function (posicao) {
        var value = false

        this.arrayModelo[posicao].inserirAqui = !this.arrayModelo[posicao].inserirAqui
        value = this.arrayModelo[posicao].inserirAqui

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        if (value === true) {
          var self = this

          var queryGet = '/' + self.formulario1.field.modelo.value + '/' + posicao

          // MONTA O FORMULARIO PARA ENVIO A API
          self.$store.state.comunicaAPI('/contrato/modelo/conteudo/menu-inserir/get' + queryGet, 'GET', null, function (apiSuccess) {
            // INICIA A VARIAVEL
            apiSuccess.data.value = ''
            apiSuccess.data.editar = false
            apiSuccess.data.campoExtra = {}

            self.arrayModelo[posicao].inserirAqui = apiSuccess.data

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }, function (apiError) {
            self.contratosModeloSetaErroAPi(apiError)
          })
        }
      },
      contratosModeloConteudoEditar: function (index) {
        // SETA A EDIÇÃO DO CAMPO
        this.arrayModelo[index].editar = !this.arrayModelo[index].editar

        if (this.arrayModelo[index].editar === true) {
          // SETA O CONTEUDO QUE ESTA SENDO EDITADO
          this.arrayModelo[index].campoExtra.value = this.arrayModelo[index].conteudo

          if (this.arrayModelo[index].campoExtra.hasOwnProperty('novaPagina')) {
            this.arrayModelo[index].campoExtra.novaPagina = this.arrayModelo[index].np
          }

          // CHAMA A FUNÇÃO PARA DAR FOCUS NO CAMPO
          this.contratosModeloFocusCampo(this.arrayModelo[index].campoExtra.tipo, this.arrayModelo[index].campoExtra.id)
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      contratosModeloConteudoAbrir: function (index) {
        // SETA O VALOR EM BRANCO PARA ABRI AS OPÇÕES DE INSERIR AQUI
        this.arrayModelo[index].value = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      contratosModeloAbrir: function (valueModelo = '', callback = null) {
        var self = this

        valueModelo = valueModelo.toString()

        if (valueModelo !== '' && self.modelos.findIndex(item => item.id === valueModelo) === -1) {
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, nome: null, ref_mod: null }, where: { f: 'status', o: '=', v: '1' } }

          self.$store.state.comunicaAPI('/contrato/modelo/get/', 'GET', queryGet, function (apiSuccess) {
            // SETA OS MODELOS RECEBIDOS
            self.modelos = apiSuccess.data

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            setTimeout(function () {
              // CHAMA A FUNÇÃO NOVAMENTE PARA DAR CONTINUIDADE NO PROCESSO
              self.contratosModeloAbrir(valueModelo, callback)
            }, 500)
          }, function (apiError) {
            self.contratosModeloSetaErroAPi(apiError)
          })
        } else if (valueModelo !== '') {
          // CARREGA OS MODELOS DA REFERENCIA SELECIONADA
          self.formulario1.field.modelo.options = self.modelos.filter(item => item.ref_mod === self.formulario1.field.referencia.value)
          self.formulario1.field.copiarModelo.options = self.modelos.filter(item => item.ref_mod === self.formulario1.field.referencia.value)

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          setTimeout(function () {
            // SETA O VALOR RECEBIDO
            self.formulario1.field.modelo.value = valueModelo

            // FAZ A FUNÇÃO ONCHANGE DO MODELO
            self.contratosModeloOnChangeValue(valueModelo, self.formulario1.field.modelo.id)

            // CHAMA A FUNÇÃO PARA CARREGAR O CONTEUDO DO MODELO
            self.contratosModeloCarregarConteudo()

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            if (callback !== null) {
              callback()
            }
          }, 500)
        } else if (valueModelo === '') {
          self.contratosModeloIniciar()
        }
      },
      contratosModeloFocusCampo: function (tipo, id, tentativa = 0) {
        var self = this

        setTimeout(function () {
          if (self.$refs.hasOwnProperty(tipo)) {
            var index = self.$refs[tipo].findIndex(item => item.cpntId === id)

            if (index !== -1) {
              if (self.$refs[tipo][index].hasOwnProperty('onFocusField')) {
                self.$refs[tipo][index].onFocusField(false)
              } else if (tentativa <= 10) {
                self.contratosModeloFocusCampo(tipo, id, (tentativa + 1))
              }
            } else if (tentativa <= 10) {
              self.contratosModeloFocusCampo(tipo, id, (tentativa + 1))
            }
          } else if (tentativa <= 10) {
            self.contratosModeloFocusCampo(tipo, id, (tentativa + 1))
          }
        }, 50)
      },
      contratosModeloScrollPosition: function (position) {
        setTimeout(function () {
          $('html, body').stop().animate({ scrollTop: position }, 500, 'swing')
        }, 500)
      }
    },
    watch: {
      '$route.params.id': function () {
        // SETA O STATUS DA TELA
        this.statusGeral = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA CARREGAR OS DADOS NOVAMENTE
        this.contratosModeloIniciar()
      }
    }
  }
</script>
